export default __webpack_public_path__ + "static/media/smiley_face_no_shadow.89f3f3d2.svg";